import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import { DefiActionBar } from "../actionBar";
import { DefiPagination } from "../pagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
const styles = {
  page: {
    width: "100%",
    height: "calc(100% - 64px)"
  },
  content: {
    margin: "0 5px",
    marginBottom: 64
  },
  title: {
    fontWeight: 300
  },
  loader: {
    height: "80%",
    textAlign: "center"
  },
  pagination: {
    width: "100%",
    position: "absolute",
    bottom: 76,
    height: 40,
    borderTop: "1px solid #ddd",
    paddingTop: 8
  }
};
class DefiPage extends Component {
  componentDidMount() {
    if (this.props.onMount) this.props.onMount();
  }
  render() {
    const _this$props = this.props,
      classes = _this$props.classes,
      children = _this$props.children,
      error = _this$props.error,
      actions = _this$props.actions,
      loading = _this$props.loading,
      pageLoader = _this$props.pageLoader,
      pagination = _this$props.pagination,
      setMaxContentHeight = _this$props.setMaxContentHeight,
      hideActionBar = _this$props.hideActionBar;
    if (error) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page,
        "data-testid": "DefiPage"
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.content,
        style: setMaxContentHeight ? {
          height: "100%"
        } : undefined,
        "data-testid": "DefiPage-error"
      }, error), /*#__PURE__*/React.createElement(DefiActionBar, null, [{
        name: "Reload",
        onClick: () => {
          if (this.props.onMount) this.props.onMount();
        },
        color: "primary"
      }]));
    }
    if (pageLoader ? pageLoader.loading : loading) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page,
        "data-testid": "DefiPage"
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.content,
        style: setMaxContentHeight ? {
          height: "100%"
        } : undefined
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.loader,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        "data-testid": "DefiPage-loading"
      }, /*#__PURE__*/React.createElement("h3", null, pageLoader ? pageLoader.message : loading), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CircularProgress, {
        className: classes.progress,
        size: 50
      }))))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.page,
      "data-testid": "DefiPage"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.content,
      style: setMaxContentHeight ? {
        height: "100%"
      } : undefined
    }, /*#__PURE__*/React.createElement("br", null), children), pagination && /*#__PURE__*/React.createElement("div", {
      className: classes.pagination
    }, pagination()), !hideActionBar && /*#__PURE__*/React.createElement(DefiActionBar, null, actions));
  }
}
export default withStyles(styles)(DefiPage);